import React, { useState, useEffect } from "react";

import {Accordion, AccordionDetails, AccordionSummary, TextField, InputAdornment, RadioGroup, Radio, FormHelperText, Box, FormControl, FormLabel, FormGroup, Checkbox, FormControlLabel, Autocomplete, IconButton} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MultilineRegulationsTextArea from '../../../Container/multiline-regulations-text-area'
import config from '../../../hoa-config';
import useFieldDisabled from "../../../hooks/useFieldDisabled";
import EditCancelConfirmationModal from "../../../shared-components/edit-cancel-confirmation";
interface HoaTrashFormProps {
    handleChange : any;
    values: any;
}

export default function HoaTrashForm(props: HoaTrashFormProps) {
    const {handleChange, values} = props;
    const { isTrashFiledDisabled, isTimeOfPlacingGarbageCansDisabled } = useFieldDisabled();
    const timeSelection = ["Dusk", "Dawn", "Sunset", "Morning", "Evening", "Night", "Time", "Undefined"];
    const daySelection = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const stateList : any = {
        storageOfWaste: [],
        visibleWaste : [],
        isSpecificGarbageCansMandatory : true,
        placingTime : '',
        hour: '',
        fromTimeSelection: '',
        fromDaySelection: '',
        fromHour: '',
        toTimeSelection: '',
        toDaySelection: '',
        toHour: '',
        typesOfTrashCans: '',
        timeOfPlacingGarbageCans : '',
        regulationOfTimeOfPlacingGarbageCans: '',
        regulationsOfTrashCansDrivewayBalconyOrPatio: '',
        regulationsOfMaintenanceTrashCans: '',
        regulationsOfOutsideBurningTrash: '',
    }

    const [state, setState] = useState(stateList);
    const [fromHourVisible, setFromHourVisible] = useState(false);
    const [toHourVisible, setToHourVisible] = useState(false);
    const [expanded1, setExpanded1] = useState(false);
    const [expanded2, setExpanded2] = useState(false); 
    const [expanded3, setExpanded3] = useState(false);
    const [isWaring, setIsWarning] = useState(false);
    const [fieldInfo, setFieldInfo] = useState({
        field: '',
        key: '',
    });

    useEffect(() => {
        if (values) {
            let tempState = { ...state };
            Object.keys(tempState).map((key) => {
                tempState[key] = values[key] || (Array.isArray(tempState[key]) ? [] : typeof tempState[key] === 'object' ? {} : '');
            })
            setState(tempState);
        }
    }, [values])

    const handleCurrentChange = (value: any, key: string, checkBoxSelectedKey:string = '') => {
        let tempState: any = { ...state };

        if(key==="isSpecificGarbageCansMandatory" && !value) {
            tempState.typesOfTrashCans = '';
        }
        if(key==="placingTime" && value === "Hours") {
            tempState.fromTimeSelection = '';
            tempState.fromDaySelection = '';
            tempState.toTimeSelection = '';
            tempState.toDaySelection = '';
            tempState.fromHour = '';
            tempState.toHour = '';
        }
        if(key==="placingTime" && value === "FromTo") {
            tempState.hour = '';
        }
        if((key==="fromTimeSelection" && value === "Time" )|| key === "fromHour") {
            setFromHourVisible(true)
        }else if(key==="fromTimeSelection" && value != "Time"){
            tempState.fromHour = '';
            setFromHourVisible(false);
        }
        if((key==="toTimeSelection" && value === "Time" )|| key === "toHour") {
            setToHourVisible(true)
        }else if(key==="toTimeSelection" && value != "Time"){
            tempState.toHour = '';
            setToHourVisible(false);
        }
        if(value == null){
            value = "";
        }
        tempState[key] = value;

        if(checkBoxSelectedKey && config.violationRegulations[checkBoxSelectedKey]) {
            tempState[config.violationRegulations[checkBoxSelectedKey]] = '';
        }
        setState(tempState);
        handleChange(tempState, 'trash');
    }

    const handleCheckBoxGroup = (checked: boolean, key: string, stateName : string) => {
        let tempValue = state[stateName];
        if(checked && !tempValue.includes(key)){
            tempValue.push(key);
        } else if(!checked && tempValue.includes(key)){
            tempValue = tempValue.filter((value: any) => {return value !== key})
        }
        handleCurrentChange(tempValue, stateName, key);
    }

    const timeClear = (event: any, state: string) => {
        if(state === 'fromHour'){
            setState((prevState: any) => ({
                ...prevState,
                fromHour: '',
              }));
        }
        if(state === 'toHour'){
            setState((prevState: any) => ({
                ...prevState,
                toHour: '',
              }));
        }
    }

    const handleConnectedFieldChange = (isChecked: boolean, field: string, key: string, regulation: string) => {
        if (!isChecked && regulation) {
            setFieldInfo({
                field: field,
                key: key,
            });
            setIsWarning(!isWaring);

        } else if (isChecked && !regulation) {
            handleCheckBoxGroup(isChecked, field, key);

        } else {
            handleCheckBoxGroup(isChecked, field, key);
        }
    }

    const unCheckWarningYesClick = () => {
        let tempValue = state[fieldInfo.key];
        if(tempValue.includes(fieldInfo.field)){
            tempValue = tempValue.filter((value: any) => {return value !== fieldInfo.field})
        }
        handleCurrentChange(tempValue, fieldInfo.key, fieldInfo.field);
        setIsWarning(false);
    }

    return (
        <>
            <Accordion
            style={{background: expanded1 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded1(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Storage of Trash
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are restricted.</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={state.storageOfWaste.includes('Trash can on driveway, balcony, or patio')} 
                                        onChange={(event) => 
                                            handleConnectedFieldChange(event.target.checked, 'Trash can on driveway, balcony, or patio', 'storageOfWaste', state.regulationsOfTrashCansDrivewayBalconyOrPatio)
                                        } 
                                        disabled={isTrashFiledDisabled('storageOfWaste') || isTrashFiledDisabled('regulationsOfTrashCansDrivewayBalconyOrPatio')}
                                    />
                                }
                                label="Trash can on driveway, balcony, or patio"
                            />
                            {
                                state.storageOfWaste.includes('Trash can on driveway, balcony, or patio') &&
                                <MultilineRegulationsTextArea 
                                    regulationType={'regulationsOfTrashCansDrivewayBalconyOrPatio'}
                                    value={state.regulationsOfTrashCansDrivewayBalconyOrPatio}
                                    handleCurrentChange={handleCurrentChange}
                                    disabled={isTrashFiledDisabled('regulationsOfTrashCansDrivewayBalconyOrPatio')}
                                />
                            }
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={state.storageOfWaste.includes('Maintenance of Trash')} 
                                        onChange={(event) => 
                                            handleConnectedFieldChange(event.target.checked, 'Maintenance of Trash', 'storageOfWaste', state.regulationsOfMaintenanceTrashCans)
                                        } 
                                        disabled={isTrashFiledDisabled('storageOfWaste') || isTrashFiledDisabled('regulationsOfMaintenanceTrashCans')}
                                    />
                                }
                                label="Maintenance of Trash"
                            />
                            {
                                state.storageOfWaste.includes('Maintenance of Trash') &&
                                <MultilineRegulationsTextArea 
                                    regulationType={'regulationsOfMaintenanceTrashCans'}
                                    value={state.regulationsOfMaintenanceTrashCans}
                                    handleCurrentChange={handleCurrentChange}
                                    disabled={isTrashFiledDisabled('regulationsOfMaintenanceTrashCans')}
                                />
                            }
                        </FormGroup>
                    </FormControl>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded2 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded2(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Visible Waste
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are restricted.</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={state.visibleWaste.includes('Trash visibility restrictions from neighboring properties')} 
                                        onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Trash visibility restrictions from neighboring properties', 'visibleWaste')} 
                                        disabled={isTrashFiledDisabled('visibleWaste')}
                                    />
                                }
                                label="Trash visibility restrictions from neighboring properties"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={state.visibleWaste.includes('Outside Burning of Trash')} 
                                        onChange={(event) => 
                                            handleConnectedFieldChange(event.target.checked, 'Outside Burning of Trash', 'visibleWaste', state.regulationsOfOutsideBurningTrash)
                                        } 
                                        disabled={isTrashFiledDisabled('visibleWaste') || isTrashFiledDisabled('regulationsOfOutsideBurningTrash')}
                                    />
                                }
                                label="Outside Burning of Trash"
                            />
                            {
                                state.visibleWaste.includes('Outside Burning of Trash') &&
                                <MultilineRegulationsTextArea 
                                    regulationType={'regulationsOfOutsideBurningTrash'}
                                    value={state.regulationsOfOutsideBurningTrash}
                                    handleCurrentChange={handleCurrentChange}
                                    disabled={isTrashFiledDisabled('regulationsOfOutsideBurningTrash')}
                                />
                            }
                        </FormGroup>
                    </FormControl>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded3 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded3(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Trash Collection
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                <div style={{margin:"24px", width: '100%', display:"flex", flexDirection:"column"}}>
                    <FormControl style={{fontSize:"14px"}}>
                        <FormLabel component="legend">Please select the options which are mandatory to perform.</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={state.isSpecificGarbageCansMandatory} 
                                        onChange={(event) => handleCurrentChange(event.target.checked, 'isSpecificGarbageCansMandatory')} 
                                        disabled={isTrashFiledDisabled('isSpecificGarbageCansMandatory') || isTrashFiledDisabled('typesOfTrashCans')}
                                    />
                                }
                                label="Specific garbage cans for trash collection"
                            />
                        </FormGroup>
                    {
                        state.isSpecificGarbageCansMandatory ?
                        <TextField style={{ width: "35%", marginRight:"10px", marginBottom:"25px" }} variant="standard" label="Types of trash cans" value={state.typesOfTrashCans}
                        onChange={(e)=>{handleCurrentChange(e.target.value, "typesOfTrashCans")}} InputLabelProps={{style:{fontSize:"14px"}}}
                        disabled={isTrashFiledDisabled('typesOfTrashCans')}
                        InputProps={{
                            style:{ padding:"7px 0px"}
                        }}/>
                        : <></>
                    }
                    </FormControl>
                    <FormControl style={{fontSize:"14px"}}>
                        <FormHelperText style={{margin: "12px 0px"}}>Time of Placing Garbage Cans</FormHelperText>
                        <RadioGroup
                            value={state.placingTime}
                            onChange={(e)=>{handleCurrentChange(e.target.value, "placingTime")}}
                        >
                            <FormControlLabel 
                                style={{fontSize:"12px", lineHeight:"16px"}} 
                                value="Hours" 
                                control={<Radio color="primary"/>} 
                                label='Set Hours' 
                                disabled={isTimeOfPlacingGarbageCansDisabled()} 
                            />
                            <FormControlLabel 
                                style={{fontSize:"12px", lineHeight:"16px"}} 
                                value="FromTo" 
                                control={<Radio color="primary"/>} 
                                label='Set "From & To"' 
                                disabled={isTimeOfPlacingGarbageCansDisabled()} 
                            />
                        </RadioGroup>
                    </FormControl>
                    {
                        state.placingTime == "Hours" ?
                        <TextField style={{margin:"24px", width: "35%", marginRight:"10px" }} variant="standard" type="number" label="No. of Hours" value={state.hour}
                        onChange={(e)=>{handleCurrentChange(e.target.value, "hour")}} InputLabelProps={{style:{fontSize:"14px", transform:"translateY(7px)"}}}
                        disabled={isTrashFiledDisabled('hour')}/>
                        : state.placingTime == "FromTo" ?
                        <>
                             <Box component="form" style={{padding: "12px", margin:"24px", display: "flex", alignItems: "center", border: "1px solid #e8e8e8", borderRadius: "4px", backgroundColor: "#fff"}}>
                                <FormLabel component="legend" style={{marginRight: "12px"}}>From</FormLabel>
                                <Autocomplete
                                    disablePortal
                                    id="time-selection-label"
                                    options={timeSelection}
                                    value={state.fromTimeSelection ? state.fromTimeSelection : ''}
                                    onChange={(e, v) => {handleCurrentChange(v, "fromTimeSelection")}}
                                    sx={{ m: 1, minWidth: 160 }}
                                    style={{background:"#FAFAFA", padding: '12px'}}
                                    disabled={isTrashFiledDisabled('fromTimeSelection')} 
                                    renderInput={(params: any) => <TextField variant="standard" {...params} label="Time Selection" />}
                                />
                                {
                                    fromHourVisible || state.fromHour ? 
                                        <TextField style={{padding: '12px', background:"#FAFAFA"}} variant="standard" type="time" label="Hours" value={state.fromHour}
                                            onChange={(e)=>{handleCurrentChange(e.target.value, "fromHour")}} InputLabelProps={{style:{fontSize:"14px", transform:"translateY(7px)"}}}
                                            disabled={isTrashFiledDisabled('fromHour')} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        { state.fromHour ? 
                                                        <IconButton disabled={isTrashFiledDisabled('fromHour')} >
                                                            <ClearIcon style={{cursor: 'pointer'}} onClick={(e) => timeClear(e, 'fromHour')} />
                                                        </IconButton>
                                                        : ''}
                                                    </InputAdornment>
                                            )}}
                                            />
                                        : <></>
                                }
                                <Autocomplete
                                    disablePortal
                                    id="day-selection-label"
                                    options={daySelection}
                                    value={state.fromDaySelection || ''}
                                    onChange={(e, v) => {handleCurrentChange(v, "fromDaySelection")}}
                                    sx={{ m: 1, minWidth: 160 }}
                                    style={{background:"#FAFAFA", padding: '12px'}}
                                    disabled={isTrashFiledDisabled('fromDaySelection')} 
                                    renderInput={(params: any) => <TextField variant="standard" {...params} label="Day Selection" />}
                                />
                            </Box>
                            <Box component="form" style={{padding: "12px", margin:"24px", display: "flex", alignItems: "center", border: "1px solid #e8e8e8", borderRadius: "4px", backgroundColor: "#fff"}}>
                                <FormLabel component="legend" style={{marginRight: "12px"}}>To</FormLabel>
                                <Autocomplete
                                    disablePortal
                                    id="time-selection-label"
                                    options={timeSelection}
                                    value={state.toTimeSelection || ''}
                                    onChange={(e, v) => {handleCurrentChange(v, "toTimeSelection")}}
                                    sx={{ m: 1, minWidth: 160 }}
                                    style={{background:"#FAFAFA", padding: '12px'}}
                                    disabled={isTrashFiledDisabled('toTimeSelection')} 
                                    renderInput={(params: any) => <TextField variant="standard" {...params} label="Time Selection" />}
                                />
                                {
                                    toHourVisible || state.toHour ? 
                                        <TextField style={{padding: '12px', background:"#FAFAFA"}} variant="standard" type="time" label="Hours" value={state.toHour}
                                            onChange={(e)=>{handleCurrentChange(e.target.value, "toHour")}} InputLabelProps={{style:{fontSize:"14px", transform:"translateY(7px)"}}}
                                            disabled={isTrashFiledDisabled('toHour')} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        { state.toHour ? 
                                                        <IconButton disabled={isTrashFiledDisabled('toHour')} >
                                                            <ClearIcon style={{cursor: 'pointer'}} onClick={(e) => timeClear(e, 'toHour')} /> 
                                                        </IconButton>
                                                        : ''}
                                                    </InputAdornment>
                                            )}}
                                            />
                                        : <></>
                                }
                                <Autocomplete
                                    disablePortal
                                    id="day-selection-label"
                                    options={daySelection}
                                    value={state.toDaySelection || ''}
                                    onChange={(e, v) => {handleCurrentChange(v, "toDaySelection")}}
                                    sx={{ m: 1, minWidth: 160 }}
                                    style={{background:"#FAFAFA", padding: '12px'}}
                                    disabled={isTrashFiledDisabled('toDaySelection')} 
                                    renderInput={(params: any) => <TextField variant="standard" {...params} label="Day Selection" />}
                                />
                            </Box>
                        </> : <></>
                    }
                    {
                        state.placingTime ?
                            <TextField 
                                style={{ width: "50%", marginRight:"10px", marginBottom:"25px" }} 
                                variant="standard" 
                                label="Regulations" 
                                multiline
                                value={state.regulationOfTimeOfPlacingGarbageCans}
                                onChange={(e)=>{handleCurrentChange(e.target.value, "regulationOfTimeOfPlacingGarbageCans")}} 
                                InputLabelProps={{style:{fontSize:"14px"}}}
                                disabled={isTrashFiledDisabled('regulationOfTimeOfPlacingGarbageCans') || isTrashFiledDisabled('placingTime')}
                                InputProps={{
                                    style:{ padding:"7px 0px"}
                                }}
                            />
                        : <></>
                    }
                </div>
                </AccordionDetails>
            </Accordion>

            <EditCancelConfirmationModal 
                label="Are you sure you want to deselect? Regulation texts will be discarded if you confirm."
                isCancelClicked={isWaring}
                setIsCancelClicked={setIsWarning}
                onCancelYesClick={unCheckWarningYesClick}
            />
        </>
    )
}